function validatePasswordRules(currentPassword, newPassword, repeatNewPassword) {

  const response = {
    valid: false,
    errorText: "",
    alertTitle:"",
    field: ""
  };

  if (newPassword.value === "") {
    response.errorText = "'New password' must be provided in order to complete authentication";
    response.alertTitle = "Empty Password";
    response.field = newPassword.id;
    return response;
  }

  if (repeatNewPassword.value === "") {
    response.errorText = "'Repeat New Password' must be provided in order to complete authentication";
    response.alertTitle = "Empty Password";
    response.field = repeatNewPassword.id;
    return response;
  }

  const oldPasswordMatch = newPassword.value === currentPassword;
  if ( oldPasswordMatch ) {
    response.errorText = "New Password cannot be the same as the Current Password";
    response.alertTitle = "Select a New Password";
    response.field = newPassword.id;
    return response;
  }

  const newPasswordMatch = newPassword.value === repeatNewPassword.value;
  if ( !newPasswordMatch ) {
    response.errorText = "New passwords entered do not match";
    response.alertTitle = "Password Mismatch";
    response.field = newPassword.id;
    return response;
  }

  const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&()\\-_+=:;<>{}])(?=.{8,})");
  if (! strongRegex.test(newPassword.value)) {
    response.alertTitle = "Password Compliance";
    const lowerCase = new RegExp("^(?=.*[a-z])");
    if (!lowerCase.test(newPassword.value)) {
      response.errorText = "Password must contain at least 1 lower case alphabetical character";
      response.field = newPassword.id;
      return response;
    }
    const upperCase = new RegExp("^(?=.*[A-Z])");
    if (!upperCase.test(newPassword.value)) {
      response.errorText = "Password must contain at least 1 upper case alphabetical character";
      response.field = newPassword.id;
      return response;
    }
    const numeric = new RegExp("^(?=.*[0-9])");
    if (!numeric.test(newPassword.value)) {
      response.errorText = "Password must contain at least 1 numeric character";
      response.field = newPassword.id;
      return response;
    }
    const special = new RegExp("^(?=.*[!@#$%^&()\\-_+=:;<>{}])");
    if (!special.test(newPassword.value)) {
      response.errorText = "Password must contain at least 1 special character\nSpecial Characters are !@#$%^&()-_+=:;<>{}";
      response.field = newPassword.id;
      return response;
    }
    const length = new RegExp("^(?=.{8,})");
    if (!length.test(newPassword.value)) {
      response.errorText = "Password must be 8 characters or longer";
      response.field = newPassword.id;
      return response;
    }
  }

  response.valid = true;
  return response;
}

export default validatePasswordRules;